import { render, staticRenderFns } from "./EditSurveyQuestion.vue?vue&type=template&id=3d2eb5b8"
import script from "./EditSurveyQuestion.vue?vue&type=script&lang=js"
export * from "./EditSurveyQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports